import Switch from './Switch'
import { ReactComponent as DialSvg } from '../../../assets/svg/dial.svg'
import { ReactComponent as InfoSvg } from '../../../assets/svg/info-duotone.svg'

const OTPChannelToggle = ({
  formattedUserPhone = '+234 xxx xxx xxxx',
  otpChannel,
  onToggle,
}) => {
  return (
    <div>
      <div
        className='d-flex align-items-center justify-content-between'
        style={{ padding: '16px 12px' }}
      >
        <div className='d-flex align-items-center gap-1'>
          <DialSvg
            width={14}
            height={14}
            color={otpChannel === 'sms' ? '#B54708' : '#FEF0C7'}
            fill={otpChannel === 'sms' ? '#B54708' : '#FEF0C7'}
          />{' '}
          <p className='fw-medium' style={{ color: '#98A2B3', fontSize: 'var(--dd-label-size, 12px)' }}>
            Use Phone number instead
          </p>
        </div>

        <Switch
          id='toggle-switch'
          checked={otpChannel === 'sms'}
          onChange={onToggle}
        />
      </div>

      <div
        style={{
          maxHeight: otpChannel === 'sms' ? '150px' : '0',
          opacity: otpChannel === 'sms' ? 1 : 0,
          overflow: 'hidden',
          transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out',
          borderTop: otpChannel === 'sms' ? '1px solid #EAECF0' : 'none',
        }}
      >
        <div style={{ padding: '16px 12px' }}>
          <div
            style={{ background: '#F5FBFF', padding: '16px 12px' }}
            className='rounded-3 text-start'
          >
            <div
              style={{
                color: '#026AA2',
                fontSize: '11px',
                marginBottom: '2px',
              }}
            >
              Enter the OTP sent to this number
            </div>
            <div
              style={{ fontSize: '14px', color: '#344054' }}
              className='fw-medium'
            >
              {formattedUserPhone}
            </div>
          </div>

          <div
            style={{ marginTop: '12px' }}
            className='d-flex align-items-center gap-1'
          >
            <InfoSvg width={12} />

            <div style={{ fontSize: '12px', color: '#344054' }}>
              Only use this if email is unavailable
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OTPChannelToggle
